import request from '@/api/request.js'

// 新增
export function LinkDetailInsert(data) {
    return request({
        url: '/api/link/linkdetailinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function LinkDetailDelete(id) {
    return request({
        url: `/api/link/linkdetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function LinkDetailUpdate(id, data) {
    return request({
        url: `/api/link/linkdetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function LinkDetailGetById(id) {
    return request({
        url: `/api/link/getlinkdetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function LinkDetailGetList(params) {
    return request({
        url: '/api/link/getlinkdetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function LinkDetailGetPageList(params) {
    return request({
        url: '/api/link/getlinkdetailpagelist',
        method: 'get',
        params: params
    })
}